<template>
  <div :style="{flex: grow + ' ' + shrink + ' ' + base}">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FlexItem',
  props: {
    grow: {
      type: [Number, String],
      default: 1
    },
    shrink: {
      type: [Number, String],
      default: 1
    },
    base: {
      type: String,
      default: 'auto'
    }
  }
};
</script>
